import styled from 'styled-components';

export const Container = styled.div`
    padding: 15px 0;
`;

export const Wrapper = styled.div`
    vertical-align: middle;
    text-align: center;

    & div {
        border-color: var(--twitter);
    }
`;
